import { FC, SVGProps } from "react";

// Not in @vygruppen/spor-icon-react - custom icon for the "Logg på" (queue) button.
export const QueueHeadsetFill24Icon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3C15.3137 3 18 5.68629 18 9L18.2041 9.01074C19.2128 9.113 20 9.96435 20 11V13C20 14.0357 19.2128 14.887 18.2041 14.9893L18 15V17C18 17.1326 17.9473 17.2597 17.8535 17.3535L15.3535 19.8535C15.2597 19.9473 15.1326 20 15 20H14V20.5C14 20.7761 13.7761 21 13.5 21H11.5C11.2239 21 11 20.7761 11 20.5V18.5C11 18.2239 11.2239 18 11.5 18H13.5C13.7761 18 14 18.2239 14 18.5V19H14.793L17 16.793V15H16.5C16.2239 15 16 14.7761 16 14.5V9.5C16 9.22386 16.2239 9 16.5 9H17C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9H7.5C7.77614 9 8 9.22386 8 9.5V14.5C8 14.7761 7.77614 15 7.5 15H6C4.89543 15 4 14.1046 4 13V11C4 9.89543 4.89543 9 6 9C6 5.68629 8.68629 3 12 3ZM12 20H13V19H12V20ZM6 10C5.44772 10 5 10.4477 5 11V13C5 13.5523 5.44772 14 6 14H7V10H6ZM17 14H18C18.5523 14 19 13.5523 19 13V11C19 10.4477 18.5523 10 18 10H17V14Z"
      fill="currentColor"
    />
  </svg>
);
